import {
  CalendarEventWriteResult,
  CreateCalendarEventInput,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type CreateExternalCalendarEventOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: CreateCalendarEventInput;
};

export const createExternalCalendarEvent = async <TFunctions>(
  options: CreateExternalCalendarEventOptions<TFunctions>,
): Promise<CalendarEventWriteResult> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    CreateCalendarEventInput,
    CalendarEventWriteResult
  >(functions, 'externalCalendars-createEvent');

  const { data } = await callable(payload);

  return data;
};
